import type { IWorkJourneyMatrixUser } from '@src/models/interfaces/workJourneyManagement.interface';

import { isMatrixCoverOnlyUser } from './isMatrixCoverOnlyUser';

/**
 * User ids that must not appear as replacement candidates in the month matrix:
 * all plantilla members (`isMember !== false`) plus the replaced user (defensive).
 * Cover-only rows stay eligible as candidates.
 */
export const buildMatrixReplacementExcludeUserIds = (
  users: readonly Pick<IWorkJourneyMatrixUser, 'id' | 'isMember'>[],
  replacedUserId?: string | null,
): string[] => {
  const ids = new Set<string>();
  users.forEach(user => {
    if (!user?.id || isMatrixCoverOnlyUser(user)) return;
    ids.add(user.id);
  });
  if (replacedUserId) {
    ids.add(replacedUserId);
  }
  return Array.from(ids);
};
